var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ChevronLandingIcon } from '@core/presentation/icons';
import { memo } from 'react';
import { twMerge } from 'tailwind-merge';
var CHEVRON_COLORS = {
    primary: '#2175F3',
    grey: '#6F7276',
};
export var Chevron = memo(function (_a) {
    var className = _a.className, _b = _a.color, color = _b === void 0 ? 'primary' : _b, _c = _a.direction, direction = _c === void 0 ? 'down' : _c, rest = __rest(_a, ["className", "color", "direction"]);
    var chevronColor = CHEVRON_COLORS[color] || color;
    return (_jsx("button", __assign({ disabled: rest.disabled, className: twMerge(className) }, rest, { children: _jsx(ChevronLandingIcon, { color: chevronColor, direction: direction }) })));
});
Chevron.displayName = 'Chevron';
